import { RangeSpec, type FilterKind, type FilterParam } from "./FilterModal.types";

export const AVAILABLE: { key: FilterKind; label: string; default?: number }[] = [
  { key: "grayscale", label: "FILTERS_MODAL.filters.grayscale", default: 0.7 },
  { key: "sepia", label: "FILTERS_MODAL.filters.sepia", default: 0.6 },
  { key: "invert", label: "FILTERS_MODAL.filters.invert", default: 1 },
  { key: "brightness", label: "FILTERS_MODAL.filters.brightness", default: 1.1 },
  { key: "blur", label: "FILTERS_MODAL.filters.blur", default: 1 },
];

export const DEFAULT_RANGE: RangeSpec = { min: 0, max: 2, step: 0.05 };
export const RANGE_BY_KIND: Partial<Record<FilterKind, RangeSpec>> = {
  blur: { min: 0, max: 10, step: 0.1 },
  grayscale: { min: 0, max: 1, step: 0.01 },
  invert: { min: 0, max: 1, step: 0.01 },
  sepia: { min: 0, max: 1, step: 0.01 },
};

export const ADVANCED_PARAMS: Partial<Record<FilterKind, FilterParam[]>> = {
  brightness: [
    {
      key: "gamma",
      label: "FILTERS_MODAL.params.gamma",
      range: { min: 0.1, max: 3, step: 0.05 },
      default: 1,
    },
    {
      key: "contrast",
      label: "FILTERS_MODAL.params.contrast",
      range: { min: 0, max: 2, step: 0.05 },
      default: 1,
    },
    {
      key: "saturation",
      label: "FILTERS_MODAL.params.saturation",
      range: { min: 0, max: 2, step: 0.05 },
      default: 1,
    },
    {
      key: "red",
      label: "FILTERS_MODAL.params.red",
      range: { min: 0, max: 2, step: 0.05 },
      default: 1,
    },
    {
      key: "green",
      label: "FILTERS_MODAL.params.green",
      range: { min: 0, max: 2, step: 0.05 },
      default: 1,
    },
    {
      key: "blue",
      label: "FILTERS_MODAL.params.blue",
      range: { min: 0, max: 2, step: 0.05 },
      default: 1,
    },
  ],
};
